"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { InstagramRoutedPage } from './deskUi/InstagramRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function InstagramSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={InstagramRoutedPage} Loading={MsgDeskLoading} />
}
